import Avatar from 'components/base/Avatar';
import { Dropdown, Nav } from 'react-bootstrap';
// import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import avatar57 from 'assets/img/team/40x40/57.webp';
import ProfileDropdownMenu from './ProfileDropdownMenu';
import AdminProfileDropdownMenu from 'admin-shiplab/AdminProfileDropdownMenu';
import { useIsAdminApp } from 'admin-shiplab/AdminAppProvider';
// import NineDotMenu from './NineDotMenu';
import { Link } from 'react-router-dom';
import ThemeToggler from 'components/common/ThemeToggler';
// import { useMemo } from 'react';
// import ViewPlansButton from './ViewPlansButton';
// import { getTrialDaysRemaining } from 'utils/trial';

const NavItems = () => {
  const isAdminApp = useIsAdminApp();
  // const trialDaysRemaining = useMemo(
  //   () => getTrialDaysRemaining(profile?.created_at),
  //   [profile?.created_at]
  // );

  return (
    <div className="navbar-nav navbar-nav-icons flex-row">
      {/* View Plans + trial countdown - temporarily disabled
      <ViewPlansButton
        renderTrigger={openPricing => (
          <Nav.Item className="d-flex align-items-center ms-2">
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="trial-tooltip">
                  Your account will continue collecting data until the trial ends.
                </Tooltip>
              }
            >
              <Nav.Link
                as="button"
                type="button"
                className="text-body-secondary fw-semibold p-0 border-0 bg-transparent shadow-none"
                style={{ fontSize: '0.9375rem', outline: 'none', boxShadow: 'none' }}
                onClick={openPricing}
              >
                Trial · {trialDaysRemaining} days
              </Nav.Link>
            </OverlayTrigger>
          </Nav.Item>
        )}
      />
      <ViewPlansButton />
      */}
      <Nav.Item className="d-flex align-items-center">
        <span
          aria-hidden="true"
          className="border-start mx-2"
          style={{ height: 20 }}
        />
      </Nav.Item>
      <Nav.Item>
        <ThemeToggler className="px-2" />
      </Nav.Item>
      
      {/* <Nav.Item>
        <Dropdown autoClose="outside" className="h-100">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link h-100"
            variant=""
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="2" cy="2" r="2" fill="currentColor"></circle>
              <circle cx="2" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="2" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="2" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="2" r="2" fill="currentColor"></circle>
            </svg>
          </Dropdown.Toggle>
          <NineDotMenu />
        </Dropdown>
      </Nav.Item> */}
      <Nav.Item>
        <Dropdown autoClose="outside" className="h-100">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link pe-0 py-0 lh-1 h-100 d-flex align-items-center"
            variant=""
          >
          <h5 className="mb-0">Profile</h5>
          </Dropdown.Toggle>
          {isAdminApp ? <AdminProfileDropdownMenu /> : <ProfileDropdownMenu />}
        </Dropdown>
      </Nav.Item>
    </div>
  );
};

export default NavItems;
